/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { ShipmentIssueDetailsFragmentDoc } from './ShipmentIssueDetailsFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IShipmentIssuesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']
}>

export type IShipmentIssuesQuery = { __typename?: 'Query' } & {
  shipment?: Types.Maybe<
    { __typename?: 'Shipment' } & Pick<Types.IShipment, 'id' | 'hasOsd' | 'hasClaims'> & {
        issues: Array<
          { __typename?: 'ShipmentIssue' } & Pick<
            Types.IShipmentIssue,
            'id' | 'createdAt' | 'updatedAt' | 'dueAt' | 'priority' | 'state' | 'summary'
          > & {
              createdBy: { __typename?: 'User' } & Pick<
                Types.IUser,
                'id' | 'parentUserId' | 'firstName' | 'lastName'
              >
              fault?: Types.Maybe<
                { __typename?: 'ShipmentIssueFault' } & Pick<
                  Types.IShipmentIssueFault,
                  'id' | 'fault'
                >
              >
              notes: Array<{ __typename?: 'Note' } & Pick<Types.INote, 'id' | 'body'>>
              owner: { __typename?: 'ShipmentIssueFollower' } & Pick<
                Types.IShipmentIssueFollower,
                'followerType' | 'followerId' | 'firstName' | 'lastName' | 'nickname'
              >
              reason?: Types.Maybe<
                { __typename?: 'ShipmentIssueReason' } & Pick<
                  Types.IShipmentIssueReason,
                  'id' | 'reason'
                >
              >
              subscribers: Array<
                { __typename?: 'ShipmentIssueFollower' } & Pick<
                  Types.IShipmentIssueFollower,
                  'followerId' | 'followerType' | 'firstName' | 'lastName' | 'nickname'
                >
              >
              suggestedOwners: Array<
                { __typename?: 'ShipmentIssueSuggestedOwner' } & Pick<
                  Types.IShipmentIssueSuggestedOwner,
                  'role'
                > & {
                    owner?: Types.Maybe<
                      { __typename?: 'ShipmentIssueFollower' } & Pick<
                        Types.IShipmentIssueFollower,
                        'followerId' | 'followerType' | 'firstName' | 'lastName'
                      >
                    >
                  }
              >
              issueResolutionSteps?: Types.Maybe<
                Array<
                  { __typename?: 'IssueResolutionStep' } & Pick<
                    Types.IIssueResolutionStep,
                    | 'id'
                    | 'issueResolutionStepId'
                    | 'description'
                    | 'stepSequence'
                    | 'completed'
                    | 'completedAt'
                    | 'completedById'
                  >
                >
              >
              type: { __typename?: 'ShipmentIssueType' } & Pick<
                Types.IShipmentIssueType,
                | 'id'
                | 'categoryId'
                | 'name'
                | 'description'
                | 'stepsToResolve'
                | 'canManuallyResolve'
              > & {
                  category?: Types.Maybe<
                    { __typename?: 'ShipmentIssueCategory' } & Pick<
                      Types.IShipmentIssueCategory,
                      'id' | 'name'
                    >
                  >
                }
              updater: { __typename?: 'User' } & Pick<
                Types.IUser,
                'id' | 'parentUserId' | 'firstName' | 'lastName'
              >
              issueStateTransitions: Array<
                { __typename?: 'ShipmentIssueStateTransition' } & Pick<
                  Types.IShipmentIssueStateTransition,
                  'id' | 'state' | 'createdAt'
                > & { createdBy: { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'> }
              >
            }
        >
      }
  >
}

export const ShipmentIssuesDocument = gql`
  query ShipmentIssues($id: ID!) {
    shipment(id: $id) {
      id
      hasOsd
      hasClaims
      issues {
        ...ShipmentIssueDetails
      }
    }
  }
  ${ShipmentIssueDetailsFragmentDoc}
`

/**
 * __useShipmentIssuesQuery__
 *
 * To run a query within a React component, call `useShipmentIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentIssuesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShipmentIssuesQuery(
  baseOptions: Apollo.QueryHookOptions<IShipmentIssuesQuery, IShipmentIssuesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IShipmentIssuesQuery, IShipmentIssuesQueryVariables>(
    ShipmentIssuesDocument,
    options
  )
}
export function useShipmentIssuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IShipmentIssuesQuery, IShipmentIssuesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IShipmentIssuesQuery, IShipmentIssuesQueryVariables>(
    ShipmentIssuesDocument,
    options
  )
}
export type ShipmentIssuesQueryHookResult = ReturnType<typeof useShipmentIssuesQuery>
export type ShipmentIssuesLazyQueryHookResult = ReturnType<typeof useShipmentIssuesLazyQuery>
export type ShipmentIssuesQueryResult = Apollo.QueryResult<
  IShipmentIssuesQuery,
  IShipmentIssuesQueryVariables
>
